import {createApp} from 'vue'
import CreateGallery from './CreateGallery'

const el = '.kb-component--create-gallery'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateGalleryDOM)=>{
            const props = {
                groupName: CreateGalleryDOM.dataset.groupName ?? "",
                groupId: CreateGalleryDOM.dataset.groupId ?? "",
                content: CreateGalleryDOM.dataset.content ? JSON.parse(CreateGalleryDOM.dataset.content) : null,
            }
            const component = createApp(CreateGallery, props).use(Store)
            component.mount(CreateGalleryDOM)
        })
    }
}